<ion-content>
	<div class="login">
		<div class="mapcom-abstract-bg">
			<div class="blue-overlay">
				<figure>
					<img
						src="../../../../../assets/images/Mapcom-Systems-Logo-WHT@0.5x.png"
						alt="MapCom Logo"
						class="logo"
					/>
				</figure>
				<ion-card>
					<ion-card-header>
						<ion-card-title>Mobile Tech Pro Login</ion-card-title>
					</ion-card-header>

					<form>
						<ion-card-content>
							<ion-item>
								<ion-label position="stacked">
									Username
								</ion-label>
								<ion-input
									required
									#autofocus
									#username
									(keyup.enter)="onSubmitLogin()"
								></ion-input>
							</ion-item>

							<ion-item>
								<ion-label position="stacked">
									Password
								</ion-label>
								<ion-input
									required
									type="password"
									#password
									(keyup.enter)="onSubmitLogin()"
								></ion-input>
							</ion-item>

							<ion-item
								lines="none"
								class="error"
								*ngIf="isLoginInvalid"
							>
								<ion-label color="danger">
									Username/Password Invalid*
								</ion-label>
							</ion-item>

							<ion-item
								lines="none"
								class="error"
								*ngIf="exceededMaxLoginAttempts"
							>
								<ion-label color="danger">
									Too many login attempts. Please try again
									later.
								</ion-label>
							</ion-item>

							<ion-button
								class="login-btn"
								expand="full"
								color="tertiary"
								type="submit"
								size="default"
								(click)="onSubmitLogin()"
							>
								Login
							</ion-button>
						</ion-card-content>
					</form>
				</ion-card>
			</div>
		</div>
	</div>
</ion-content>
